exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".force-footer{height:70px;background:linear-gradient(254.93deg,#1a0f6b 2.82%,#1c116f 28.98%,#21177a 54.17%,#2a218d 78.39%,#352da5 99.71%)}.new-row{height:100%}.new-row .new-footer{height:100%;display:flex;align-items:center;justify-content:center;flex-direction:column}.new-row .new-footer .footer-art{display:flex;align-items:flex-end}.new-row .new-footer .footer-art img{margin-right:10px}.new-row .new-footer .footer-art a{text-decoration:none;cursor:pointer;margin-right:10px}.new-row .new-footer .footer-art a:last-child{margin-right:0;margin-bottom:1px}.new-row .new-footer .footer-art a ion-icon{color:#fff;font-size:18px}.new-row .new-footer .copyright{margin-top:5px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-63fa72b9","scoped":false,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/vue/views/components/footer.vue
// module id = 889
// module chunks = 0